export type PartnerApp =
  | "hospital"
  | "laboratory"
  | "insurance";

export function getPartnerApp(): PartnerApp {
  const configuredPartner =
    import.meta.env.VITE_PARTNER_TYPE;

  if (
    configuredPartner === "laboratory" ||
    configuredPartner === "insurance" ||
    configuredPartner === "hospital"
  ) {
    return configuredPartner;
  }

  if (typeof window !== "undefined") {
    const hostname =
      window.location.hostname.toLowerCase();

    if (
      hostname.startsWith(
        "laboratorypartners.",
      )
    ) {
      return "laboratory";
    }

    if (
      hostname.startsWith(
        "insurancepartners.",
      )
    ) {
      return "insurance";
    }
  }

  return "hospital";
}

export function isLaboratoryPartnerApp() {
  return getPartnerApp() === "laboratory";
}

export function isInsurancePartnerApp() {
  return getPartnerApp() === "insurance";
}

export function getPartnerAppName(): string {
  const names: Record<PartnerApp, string> = {
    hospital: "GluviaCare+ Hospital & Clinic Partners",
    laboratory: "GluviaCare+ Laboratory Partners",
    insurance: "GluviaCare+ Insurance Partners",
  };

  return names[getPartnerApp()];
}
